import {
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  IconButton,
  useColorModeValue,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { CustomSearchIcon } from '../../theme/icons/CustomSearchIcon';

export function CustomSearchbar(props) {
  const modeBgColor = useColorModeValue('white', 'secondaryDark');
  const hasValue = Boolean(props.inputSearch?.trim());

  const handleInputSearch = (e) => {
    const value = e.target.value;
    props.setInputSearch(value);
  };

  const handleClear = () => {
    props.setInputSearch('');
  };

  return (
    <InputGroup
      w={props.w ?? { base: '100%', sm: '60%' }}
      minW={props.minW}
      mr={2}
    >
      <InputLeftElement
        data-testid="search-icon"
        height="full"
        justifyContent="start"
        pl="12px"
        children={<CustomSearchIcon name="search" boxSize="16px" />}
      />
      <Input
        borderRadius="5px"
        _focus={{ borderColor: '#3A4A57', borderWidth: '2px' }}
        alignSelf={{ base: 'flex-start', sm: 'center' }}
        pl="35px"
        pr={hasValue ? '75px' : '40px'}
        fontSize="13px"
        fontWeight="bold"
        w="full"
        bg={modeBgColor}
        height="38px"
        type="text"
        placeholder={props.placeholder ?? 'Search by name'}
        _placeholder={{ color: '#989898', letterSpacing: '0.3px' }}
        value={props.inputSearch}
        onChange={handleInputSearch}
      />
      {hasValue && (
        <InputRightElement height="36px" width="40px" pr="4px">
          <IconButton
            aria-label="Clear search"
            icon={<CloseIcon boxSize="10px" />}
            size="sm"
            variant="ghost"
            color="#989898"
            onClick={handleClear}
            data-testid="search-clear"
            _hover={{ bg: 'none', color: '#4C4C4C' }}
          />
        </InputRightElement>
      )}
    </InputGroup>
  );
}
